import { Button, Grid, Typography } from "@mui/material";
import { IOrder, IOwnFleetTabProps } from "../../../interfaces/order";
import { MEDIUM, MERCHANT } from "../../../utils/constants";
import { hasAvailableStatusTransition } from "../../../utils/orderStatus";
import GenericAlert from "../../GenericAlert";
import Loader from "../../Loader";
import ListOrders from "../../tables/ListOrders";
import FiltersHeaderContainer from "../FiltersHeaderContainer";


const OwnFleetTab = ({
  showFilters,
  handleChangeFilter,
  alert,
  setAlert,
  aliases,
  loaderPage,
  orders,
  entity,
  pagination,
  handlePageChange,
  handleSelectedAction,
  showActions,
  rules,
  selectedOrders,
  setSelectedOrders,
  setOpenEditModal,
  allowedStatusIds,
  availableSorts,
  appliedSort,
  availableFilters,
  setShowBulkUpdate
}: IOwnFleetTabProps & {
  showBulkUpdate: boolean;
  setShowBulkUpdate: (_value: boolean) => void;
}) => {
  const shouldDisableEdit = !selectedOrders.every(
    ({ service, status }) =>
      selectedOrders[0]?.service === service &&
      selectedOrders[0]?.status === status
  );
  const handleSelectOrder = (order: IOrder) => {
    const orderIsSelected = !!selectedOrders.find(
      ({ _id }) => _id === order._id
    );
    if (orderIsSelected) {
      const filteredSelectedOrders = selectedOrders.filter(
        ({ _id }) => _id !== order._id
      );
      setSelectedOrders(filteredSelectedOrders);
      return;
    }
    setSelectedOrders([...selectedOrders, order]);
  };

  const handleSelectAllOrders = (checked: boolean) =>
    setSelectedOrders(
      checked
        ? orders.filter(({ service, status }) =>
          hasAvailableStatusTransition(service, status, true)
        )
        : []
    );

  return (
    <>
      <Grid container marginTop="36px" gap="66px" alignItems={"center"}>
        <Grid item>
          <Typography className="f-s-20">Flete propio</Typography>
        </Grid>
        {(entity === MERCHANT) && <Grid item>
          <Button variant="outlined" onClick={() => setShowBulkUpdate(true)}>Actualizar estados por CSV</Button>
        </Grid>}
      </Grid>
      <br />
      {showFilters && (
        <FiltersHeaderContainer
          handleChangeFilter={handleChangeFilter}
          setAlert={setAlert}
          aliases={aliases}
          loaderPage={loaderPage}
          selectedOrdersCount={selectedOrders.length}
          setOpenEditModal={setOpenEditModal}
          disableEdit={shouldDisableEdit}
          isOwnFleet
          allowedStatusIds={allowedStatusIds}
          availableSorts={availableSorts}
          appliedSort={appliedSort}
          availableFilters={availableFilters}
        />
      )}
      {alert.showAlert && <GenericAlert alert={alert} />}
      {loaderPage && <Loader size={MEDIUM} />}
      {!loaderPage && orders.length > 0 && (
        <ListOrders
          orders={orders}
          entity={entity}
          pagination={pagination}
          handlePageChange={handlePageChange}
          handleSelectedAction={handleSelectedAction}
          showActions={showActions}
          rules={rules}
          selectedOrders={selectedOrders}
          onCheckOrder={(order) => handleSelectOrder(order)}
          onCheckAll={handleSelectAllOrders}
          availableSorts={availableSorts}
          appliedSort={appliedSort}
          handleChangeFilter={handleChangeFilter}
        />
      )}
    </>
  );
};

export default OwnFleetTab;
